// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as CitySlugRouteImport } from './routes/$citySlug'
import { Route as AuthenticatedRouteImport } from './routes/_authenticated'
import { Route as AiRouteImport } from './routes/ai'
import { Route as BusinessRouteImport } from './routes/business'
import { Route as CitiesRouteImport } from './routes/cities'
import { Route as ContactRouteImport } from './routes/contact'
import { Route as CrmRouteImport } from './routes/crm'
import { Route as DoRouteImport } from './routes/do'
import { Route as EatRouteImport } from './routes/eat'
import { Route as FiRouteImport } from './routes/fi'
import { Route as HelpRouteImport } from './routes/help'
import { Route as LoginRouteImport } from './routes/login'
import { Route as MapRouteImport } from './routes/map'
import { Route as MyEventsRouteImport } from './routes/my-events'
import { Route as OnboardingRouteImport } from './routes/onboarding'
import { Route as PrivacyRouteImport } from './routes/privacy'
import { Route as ProfileRouteImport } from './routes/profile'
import { Route as ReferRouteImport } from './routes/refer'
import { Route as RegisterRouteImport } from './routes/register'
import { Route as SavedRouteImport } from './routes/saved'
import { Route as SearchRouteImport } from './routes/search'
import { Route as SubmitEventRouteImport } from './routes/submit-event'
import { Route as TermsRouteImport } from './routes/terms'
import { Route as TrainFactoryRouteImport } from './routes/train-factory'
import { Route as VenueEventsRouteImport } from './routes/venue-events'
import { Route as AuthenticatedAgreementsRouteImport } from './routes/_authenticated/agreements'
import { Route as AuthenticatedBusinessAdminRouteImport } from './routes/_authenticated/business-admin'
import { Route as AuthenticatedCityRouteImport } from './routes/_authenticated/city'
import { Route as AuthenticatedCityHubRouteImport } from './routes/_authenticated/city-hub'
import { Route as AuthenticatedCityTasksRouteImport } from './routes/_authenticated/city-tasks'
import { Route as AuthenticatedStorageCheckRouteImport } from './routes/_authenticated/storage-check'
import { Route as AuthenticatedVenueManagerRouteImport } from './routes/_authenticated/venue-manager'
import { Route as AcceptTokenRouteImport } from './routes/accept.$token'
import { Route as AdminLoginRouteImport } from './routes/admin.login'
import { Route as BarsIndexRouteImport } from './routes/bars.index'
import { Route as BarsSlugRouteImport } from './routes/bars.$slug'
import { Route as BusinessIndexRouteImport } from './routes/business.index'
import { Route as BusinessCitiesRouteImport } from './routes/business.cities'
import { Route as BusinessEventsRouteImport } from './routes/business.events'
import { Route as CafesIndexRouteImport } from './routes/cafes.index'
import { Route as CafesSlugRouteImport } from './routes/cafes.$slug'
import { Route as CityHubSlugRouteImport } from './routes/city-hub.$slug'
import { Route as CityInviteTokenRouteImport } from './routes/city-invite.$token'
import { Route as CrmIndexRouteImport } from './routes/crm.index'
import { Route as CrmClientIdRouteImport } from './routes/crm.$clientId'
import { Route as CrmAccessRouteImport } from './routes/crm.access'
import { Route as CrmApplicationsRouteImport } from './routes/crm.applications'
import { Route as CrmChatRouteImport } from './routes/crm.chat'
import { Route as CrmClosedDealsRouteImport } from './routes/crm.closed-deals'
import { Route as CrmDashboardRouteImport } from './routes/crm.dashboard'
import { Route as CrmInvoicesRouteImport } from './routes/crm.invoices'
import { Route as CrmLogsRouteImport } from './routes/crm.logs'
import { Route as CrmMapRouteImport } from './routes/crm.map'
import { Route as CrmMyWorkRouteImport } from './routes/crm.my-work'
import { Route as CrmProfileRouteImport } from './routes/crm.profile'
import { Route as CrmReportsRouteImport } from './routes/crm.reports'
import { Route as CrmSalesRouteImport } from './routes/crm.sales'
import { Route as CrmSmmRouteImport } from './routes/crm.smm'
import { Route as CrmTasksRouteImport } from './routes/crm.tasks'
import { Route as DistrictsIndexRouteImport } from './routes/districts.index'
import { Route as DistrictsSlugRouteImport } from './routes/districts.$slug'
import { Route as FiIndexRouteImport } from './routes/fi/index'
import { Route as FiCitySlugRouteImport } from './routes/fi/$citySlug'
import { Route as FiCitiesRouteImport } from './routes/fi/cities'
import { Route as FiDoRouteImport } from './routes/fi/do'
import { Route as FiEatRouteImport } from './routes/fi/eat'
import { Route as Guides48HoursInHelsinkiRouteImport } from './routes/guides.48-hours-in-helsinki'
import { Route as GuidesBestSaunasHelsinkiRouteImport } from './routes/guides.best-saunas-helsinki'
import { Route as GuidesHelsinkiNeighborhoodsRouteImport } from './routes/guides.helsinki-neighborhoods'
import { Route as HappeningIndexRouteImport } from './routes/happening.index'
import { Route as HappeningSlugRouteImport } from './routes/happening.$slug'
import { Route as HelsinkiofficialFeedRouteImport } from './routes/helsinkiofficial.feed'
import { Route as HelsinkiofficialStoriesRouteImport } from './routes/helsinkiofficial.stories'
import { Route as MenuSlugRouteImport } from './routes/menu.$slug'
import { Route as MenusIndexRouteImport } from './routes/menus.index'
import { Route as NationalParksIndexRouteImport } from './routes/national-parks.index'
import { Route as NationalParksSlugRouteImport } from './routes/national-parks.$slug'
import { Route as OnboardTokenRouteImport } from './routes/onboard.$token'
import { Route as PartnerApplyRouteImport } from './routes/partner.apply'
import { Route as PartnerLoginRouteImport } from './routes/partner.login'
import { Route as PartnerRegisterRouteImport } from './routes/partner.register'
import { Route as PlaceIdRouteImport } from './routes/place.$id'
import { Route as PubsIndexRouteImport } from './routes/pubs.index'
import { Route as PubsSlugRouteImport } from './routes/pubs.$slug'
import { Route as RestaurantsIndexRouteImport } from './routes/restaurants.index'
import { Route as RestaurantsSlugRouteImport } from './routes/restaurants.$slug'
import { Route as SaunasIndexRouteImport } from './routes/saunas.index'
import { Route as SaunasSlugRouteImport } from './routes/saunas.$slug'
import { Route as SignTokenRouteImport } from './routes/sign.$token'
import { Route as SkiResortsIndexRouteImport } from './routes/ski-resorts.index'
import { Route as SkiResortsSlugRouteImport } from './routes/ski-resorts.$slug'
import { Route as TicketTokenRouteImport } from './routes/ticket.$token'
import { Route as TicketsIndexRouteImport } from './routes/tickets.index'
import { Route as TicketsSlugRouteImport } from './routes/tickets.$slug'
import { Route as AuthenticatedAdminIndexRouteImport } from './routes/_authenticated/admin.index'
import { Route as AuthenticatedAdminPageRouteImport } from './routes/_authenticated/admin.$page'
import { Route as AuthenticatedAdminAffiliateLinksRouteImport } from './routes/_authenticated/admin.affiliate-links'
import { Route as AuthenticatedAdminApplicationsRouteImport } from './routes/_authenticated/admin.applications'
import { Route as AuthenticatedAdminBackupsRouteImport } from './routes/_authenticated/admin.backups'
import { Route as AuthenticatedAdminCityHubQueueRouteImport } from './routes/_authenticated/admin.city-hub-queue'
import { Route as AuthenticatedAdminCitySubmissionsRouteImport } from './routes/_authenticated/admin.city-submissions'
import { Route as AuthenticatedAdminCityTeamsRouteImport } from './routes/_authenticated/admin.city-teams'
import { Route as AuthenticatedAdminCityTilesRouteImport } from './routes/_authenticated/admin.city-tiles'
import { Route as AuthenticatedAdminCompressImagesRouteImport } from './routes/_authenticated/admin.compress-images'
import { Route as AuthenticatedAdminDistrictsRouteImport } from './routes/_authenticated/admin.districts'
import { Route as AuthenticatedAdminImageOptimizationRouteImport } from './routes/_authenticated/admin.image-optimization'
import { Route as AuthenticatedAdminLandmarksRouteImport } from './routes/_authenticated/admin.landmarks'
import { Route as AuthenticatedAdminListingRevisionsRouteImport } from './routes/_authenticated/admin.listing-revisions'
import { Route as AuthenticatedAdminLocationsRouteImport } from './routes/_authenticated/admin.locations'
import { Route as AuthenticatedAdminMenusRouteImport } from './routes/_authenticated/admin.menus'
import { Route as AuthenticatedAdminMigrateRouteImport } from './routes/_authenticated/admin.migrate'
import { Route as AuthenticatedAdminMigrationAuditRouteImport } from './routes/_authenticated/admin.migration-audit'
import { Route as AuthenticatedAdminOnboardingLiveSyncRouteImport } from './routes/_authenticated/admin.onboarding-live-sync'
import { Route as AuthenticatedAdminPartnerEventsRouteImport } from './routes/_authenticated/admin.partner-events'
import { Route as AuthenticatedAdminPartnersRouteImport } from './routes/_authenticated/admin.partners'
import { Route as AuthenticatedAdminPublishQueueRouteImport } from './routes/_authenticated/admin.publish-queue'
import { Route as AuthenticatedAdminSeoFixesRouteImport } from './routes/_authenticated/admin.seo-fixes'
import { Route as AuthenticatedAdminServiceRequestsRouteImport } from './routes/_authenticated/admin.service-requests'
import { Route as AuthenticatedAdminTicketRoutesRouteImport } from './routes/_authenticated/admin.ticket-routes'
import { Route as AuthenticatedAdminTrainFactoryUsersRouteImport } from './routes/_authenticated/admin.train-factory-users'
import { Route as AuthenticatedAdminTranslationsRouteImport } from './routes/_authenticated/admin.translations'
import { Route as AuthenticatedPartnerIndexRouteImport } from './routes/_authenticated/partner.index'
import { Route as AuthenticatedPartnerClientIdRouteImport } from './routes/_authenticated/partner.$clientId'
import { Route as AuthenticatedPartnerOnboardingRouteImport } from './routes/_authenticated/partner.onboarding'
import { Route as AuthenticatedPartnerPendingRouteImport } from './routes/_authenticated/partner.pending'
import { Route as AuthenticatedPartnerSetPasswordRouteImport } from './routes/_authenticated/partner.set-password'
import { Route as BusinessCategoryKeyRouteImport } from './routes/business.category.$key'
import { Route as ContractsAcceptTokenRouteImport } from './routes/contracts.accept.$token'
import { Route as CrmDiagnosticsLocationsRouteImport } from './routes/crm.diagnostics.locations'
import { Route as CrmReportsContactsRouteImport } from './routes/crm.reports.contacts'
import { Route as CrmReportsMonthlyRouteImport } from './routes/crm.reports.monthly'
import { Route as CrmSalesUserIdRouteImport } from './routes/crm.sales.$userId'
import { Route as CrmSettingsRemindersRouteImport } from './routes/crm.settings.reminders'
import { Route as CrmSmmIndexRouteImport } from './routes/crm.smm.index'
import { Route as CrmSmmMembersRouteImport } from './routes/crm.smm.members'
import { Route as CrmSmmReportsRouteImport } from './routes/crm.smm.reports'
import { Route as FiBarsIndexRouteImport } from './routes/fi/bars.index'
import { Route as FiBarsSlugRouteImport } from './routes/fi/bars.$slug'
import { Route as FiCafesIndexRouteImport } from './routes/fi/cafes.index'
import { Route as FiCafesSlugRouteImport } from './routes/fi/cafes.$slug'
import { Route as FiHappeningIndexRouteImport } from './routes/fi/happening.index'
import { Route as FiHappeningSlugRouteImport } from './routes/fi/happening.$slug'
import { Route as FiMenusIndexRouteImport } from './routes/fi/menus.index'
import { Route as FiNationalParksIndexRouteImport } from './routes/fi/national-parks.index'
import { Route as FiNationalParksSlugRouteImport } from './routes/fi/national-parks.$slug'
import { Route as FiPlaceIdRouteImport } from './routes/fi/place.$id'
import { Route as FiPubsIndexRouteImport } from './routes/fi/pubs.index'
import { Route as FiPubsSlugRouteImport } from './routes/fi/pubs.$slug'
import { Route as FiRestaurantsIndexRouteImport } from './routes/fi/restaurants.index'
import { Route as FiRestaurantsSlugRouteImport } from './routes/fi/restaurants.$slug'
import { Route as FiSaunasIndexRouteImport } from './routes/fi/saunas.index'
import { Route as FiSaunasSlugRouteImport } from './routes/fi/saunas.$slug'
import { Route as FiSkiResortsIndexRouteImport } from './routes/fi/ski-resorts.index'
import { Route as FiSkiResortsSlugRouteImport } from './routes/fi/ski-resorts.$slug'
import { Route as TicketsConfirmationOrderIdRouteImport } from './routes/tickets.confirmation.$orderId'
import { Route as AuthenticatedAdminMenusSlugRouteImport } from './routes/_authenticated/admin.menus.$slug'
import { Route as AuthenticatedDistrictsSlugManageRouteImport } from './routes/_authenticated/districts.$slug.manage'

const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const CitySlugRoute = CitySlugRouteImport.update({
            id: '/$citySlug',path: '/$citySlug',getParentRoute: () => rootRouteImport
          })
const AuthenticatedRoute = AuthenticatedRouteImport.update({
            id: '/_authenticated',getParentRoute: () => rootRouteImport
          })
const AiRoute = AiRouteImport.update({
            id: '/ai',path: '/ai',getParentRoute: () => rootRouteImport
          })
const BusinessRoute = BusinessRouteImport.update({
            id: '/business',path: '/business',getParentRoute: () => rootRouteImport
          })
const CitiesRoute = CitiesRouteImport.update({
            id: '/cities',path: '/cities',getParentRoute: () => rootRouteImport
          })
const ContactRoute = ContactRouteImport.update({
            id: '/contact',path: '/contact',getParentRoute: () => rootRouteImport
          })
const CrmRoute = CrmRouteImport.update({
            id: '/crm',path: '/crm',getParentRoute: () => rootRouteImport
          })
const DoRoute = DoRouteImport.update({
            id: '/do',path: '/do',getParentRoute: () => rootRouteImport
          })
const EatRoute = EatRouteImport.update({
            id: '/eat',path: '/eat',getParentRoute: () => rootRouteImport
          })
const FiRoute = FiRouteImport.update({
            id: '/fi',path: '/fi',getParentRoute: () => rootRouteImport
          })
const HelpRoute = HelpRouteImport.update({
            id: '/help',path: '/help',getParentRoute: () => rootRouteImport
          })
const LoginRoute = LoginRouteImport.update({
            id: '/login',path: '/login',getParentRoute: () => rootRouteImport
          })
const MapRoute = MapRouteImport.update({
            id: '/map',path: '/map',getParentRoute: () => rootRouteImport
          })
const MyEventsRoute = MyEventsRouteImport.update({
            id: '/my-events',path: '/my-events',getParentRoute: () => rootRouteImport
          })
const OnboardingRoute = OnboardingRouteImport.update({
            id: '/onboarding',path: '/onboarding',getParentRoute: () => rootRouteImport
          })
const PrivacyRoute = PrivacyRouteImport.update({
            id: '/privacy',path: '/privacy',getParentRoute: () => rootRouteImport
          })
const ProfileRoute = ProfileRouteImport.update({
            id: '/profile',path: '/profile',getParentRoute: () => rootRouteImport
          })
const ReferRoute = ReferRouteImport.update({
            id: '/refer',path: '/refer',getParentRoute: () => rootRouteImport
          })
const RegisterRoute = RegisterRouteImport.update({
            id: '/register',path: '/register',getParentRoute: () => rootRouteImport
          })
const SavedRoute = SavedRouteImport.update({
            id: '/saved',path: '/saved',getParentRoute: () => rootRouteImport
          })
const SearchRoute = SearchRouteImport.update({
            id: '/search',path: '/search',getParentRoute: () => rootRouteImport
          })
const SubmitEventRoute = SubmitEventRouteImport.update({
            id: '/submit-event',path: '/submit-event',getParentRoute: () => rootRouteImport
          })
const TermsRoute = TermsRouteImport.update({
            id: '/terms',path: '/terms',getParentRoute: () => rootRouteImport
          })
const TrainFactoryRoute = TrainFactoryRouteImport.update({
            id: '/train-factory',path: '/train-factory',getParentRoute: () => rootRouteImport
          })
const VenueEventsRoute = VenueEventsRouteImport.update({
            id: '/venue-events',path: '/venue-events',getParentRoute: () => rootRouteImport
          })
const AuthenticatedAgreementsRoute = AuthenticatedAgreementsRouteImport.update({
            id: '/agreements',path: '/agreements',getParentRoute: () => AuthenticatedRoute
          })
const AuthenticatedBusinessAdminRoute = AuthenticatedBusinessAdminRouteImport.update({
            id: '/business-admin',path: '/business-admin',getParentRoute: () => AuthenticatedRoute
          })
const AuthenticatedCityRoute = AuthenticatedCityRouteImport.update({
            id: '/city',path: '/city',getParentRoute: () => AuthenticatedRoute
          })
const AuthenticatedCityHubRoute = AuthenticatedCityHubRouteImport.update({
            id: '/city-hub',path: '/city-hub',getParentRoute: () => AuthenticatedRoute
          })
const AuthenticatedCityTasksRoute = AuthenticatedCityTasksRouteImport.update({
            id: '/city-tasks',path: '/city-tasks',getParentRoute: () => AuthenticatedRoute
          })
const AuthenticatedStorageCheckRoute = AuthenticatedStorageCheckRouteImport.update({
            id: '/storage-check',path: '/storage-check',getParentRoute: () => AuthenticatedRoute
          })
const AuthenticatedVenueManagerRoute = AuthenticatedVenueManagerRouteImport.update({
            id: '/venue-manager',path: '/venue-manager',getParentRoute: () => AuthenticatedRoute
          })
const AcceptTokenRoute = AcceptTokenRouteImport.update({
            id: '/accept/$token',path: '/accept/$token',getParentRoute: () => rootRouteImport
          })
const AdminLoginRoute = AdminLoginRouteImport.update({
            id: '/admin/login',path: '/admin/login',getParentRoute: () => rootRouteImport
          })
const BarsIndexRoute = BarsIndexRouteImport.update({
            id: '/bars/',path: '/bars/',getParentRoute: () => rootRouteImport
          })
const BarsSlugRoute = BarsSlugRouteImport.update({
            id: '/bars/$slug',path: '/bars/$slug',getParentRoute: () => rootRouteImport
          })
const BusinessIndexRoute = BusinessIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => BusinessRoute
          })
const BusinessCitiesRoute = BusinessCitiesRouteImport.update({
            id: '/cities',path: '/cities',getParentRoute: () => BusinessRoute
          })
const BusinessEventsRoute = BusinessEventsRouteImport.update({
            id: '/events',path: '/events',getParentRoute: () => BusinessRoute
          })
const CafesIndexRoute = CafesIndexRouteImport.update({
            id: '/cafes/',path: '/cafes/',getParentRoute: () => rootRouteImport
          })
const CafesSlugRoute = CafesSlugRouteImport.update({
            id: '/cafes/$slug',path: '/cafes/$slug',getParentRoute: () => rootRouteImport
          })
const CityHubSlugRoute = CityHubSlugRouteImport.update({
            id: '/city-hub/$slug',path: '/city-hub/$slug',getParentRoute: () => rootRouteImport
          })
const CityInviteTokenRoute = CityInviteTokenRouteImport.update({
            id: '/city-invite/$token',path: '/city-invite/$token',getParentRoute: () => rootRouteImport
          })
const CrmIndexRoute = CrmIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => CrmRoute
          })
const CrmClientIdRoute = CrmClientIdRouteImport.update({
            id: '/$clientId',path: '/$clientId',getParentRoute: () => CrmRoute
          })
const CrmAccessRoute = CrmAccessRouteImport.update({
            id: '/access',path: '/access',getParentRoute: () => CrmRoute
          })
const CrmApplicationsRoute = CrmApplicationsRouteImport.update({
            id: '/applications',path: '/applications',getParentRoute: () => CrmRoute
          })
const CrmChatRoute = CrmChatRouteImport.update({
            id: '/chat',path: '/chat',getParentRoute: () => CrmRoute
          })
const CrmClosedDealsRoute = CrmClosedDealsRouteImport.update({
            id: '/closed-deals',path: '/closed-deals',getParentRoute: () => CrmRoute
          })
const CrmDashboardRoute = CrmDashboardRouteImport.update({
            id: '/dashboard',path: '/dashboard',getParentRoute: () => CrmRoute
          })
const CrmInvoicesRoute = CrmInvoicesRouteImport.update({
            id: '/invoices',path: '/invoices',getParentRoute: () => CrmRoute
          })
const CrmLogsRoute = CrmLogsRouteImport.update({
            id: '/logs',path: '/logs',getParentRoute: () => CrmRoute
          })
const CrmMapRoute = CrmMapRouteImport.update({
            id: '/map',path: '/map',getParentRoute: () => CrmRoute
          })
const CrmMyWorkRoute = CrmMyWorkRouteImport.update({
            id: '/my-work',path: '/my-work',getParentRoute: () => CrmRoute
          })
const CrmProfileRoute = CrmProfileRouteImport.update({
            id: '/profile',path: '/profile',getParentRoute: () => CrmRoute
          })
const CrmReportsRoute = CrmReportsRouteImport.update({
            id: '/reports',path: '/reports',getParentRoute: () => CrmRoute
          })
const CrmSalesRoute = CrmSalesRouteImport.update({
            id: '/sales',path: '/sales',getParentRoute: () => CrmRoute
          })
const CrmSmmRoute = CrmSmmRouteImport.update({
            id: '/smm',path: '/smm',getParentRoute: () => CrmRoute
          })
const CrmTasksRoute = CrmTasksRouteImport.update({
            id: '/tasks',path: '/tasks',getParentRoute: () => CrmRoute
          })
const DistrictsIndexRoute = DistrictsIndexRouteImport.update({
            id: '/districts/',path: '/districts/',getParentRoute: () => rootRouteImport
          })
const DistrictsSlugRoute = DistrictsSlugRouteImport.update({
            id: '/districts/$slug',path: '/districts/$slug',getParentRoute: () => rootRouteImport
          })
const FiIndexRoute = FiIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => FiRoute
          })
const FiCitySlugRoute = FiCitySlugRouteImport.update({
            id: '/$citySlug',path: '/$citySlug',getParentRoute: () => FiRoute
          })
const FiCitiesRoute = FiCitiesRouteImport.update({
            id: '/cities',path: '/cities',getParentRoute: () => FiRoute
          })
const FiDoRoute = FiDoRouteImport.update({
            id: '/do',path: '/do',getParentRoute: () => FiRoute
          })
const FiEatRoute = FiEatRouteImport.update({
            id: '/eat',path: '/eat',getParentRoute: () => FiRoute
          })
const Guides48HoursInHelsinkiRoute = Guides48HoursInHelsinkiRouteImport.update({
            id: '/guides/48-hours-in-helsinki',path: '/guides/48-hours-in-helsinki',getParentRoute: () => rootRouteImport
          })
const GuidesBestSaunasHelsinkiRoute = GuidesBestSaunasHelsinkiRouteImport.update({
            id: '/guides/best-saunas-helsinki',path: '/guides/best-saunas-helsinki',getParentRoute: () => rootRouteImport
          })
const GuidesHelsinkiNeighborhoodsRoute = GuidesHelsinkiNeighborhoodsRouteImport.update({
            id: '/guides/helsinki-neighborhoods',path: '/guides/helsinki-neighborhoods',getParentRoute: () => rootRouteImport
          })
const HappeningIndexRoute = HappeningIndexRouteImport.update({
            id: '/happening/',path: '/happening/',getParentRoute: () => rootRouteImport
          })
const HappeningSlugRoute = HappeningSlugRouteImport.update({
            id: '/happening/$slug',path: '/happening/$slug',getParentRoute: () => rootRouteImport
          })
const HelsinkiofficialFeedRoute = HelsinkiofficialFeedRouteImport.update({
            id: '/helsinkiofficial/feed',path: '/helsinkiofficial/feed',getParentRoute: () => rootRouteImport
          })
const HelsinkiofficialStoriesRoute = HelsinkiofficialStoriesRouteImport.update({
            id: '/helsinkiofficial/stories',path: '/helsinkiofficial/stories',getParentRoute: () => rootRouteImport
          })
const MenuSlugRoute = MenuSlugRouteImport.update({
            id: '/menu/$slug',path: '/menu/$slug',getParentRoute: () => rootRouteImport
          })
const MenusIndexRoute = MenusIndexRouteImport.update({
            id: '/menus/',path: '/menus/',getParentRoute: () => rootRouteImport
          })
const NationalParksIndexRoute = NationalParksIndexRouteImport.update({
            id: '/national-parks/',path: '/national-parks/',getParentRoute: () => rootRouteImport
          })
const NationalParksSlugRoute = NationalParksSlugRouteImport.update({
            id: '/national-parks/$slug',path: '/national-parks/$slug',getParentRoute: () => rootRouteImport
          })
const OnboardTokenRoute = OnboardTokenRouteImport.update({
            id: '/onboard/$token',path: '/onboard/$token',getParentRoute: () => rootRouteImport
          })
const PartnerApplyRoute = PartnerApplyRouteImport.update({
            id: '/partner/apply',path: '/partner/apply',getParentRoute: () => rootRouteImport
          })
const PartnerLoginRoute = PartnerLoginRouteImport.update({
            id: '/partner/login',path: '/partner/login',getParentRoute: () => rootRouteImport
          })
const PartnerRegisterRoute = PartnerRegisterRouteImport.update({
            id: '/partner/register',path: '/partner/register',getParentRoute: () => rootRouteImport
          })
const PlaceIdRoute = PlaceIdRouteImport.update({
            id: '/place/$id',path: '/place/$id',getParentRoute: () => rootRouteImport
          })
const PubsIndexRoute = PubsIndexRouteImport.update({
            id: '/pubs/',path: '/pubs/',getParentRoute: () => rootRouteImport
          })
const PubsSlugRoute = PubsSlugRouteImport.update({
            id: '/pubs/$slug',path: '/pubs/$slug',getParentRoute: () => rootRouteImport
          })
const RestaurantsIndexRoute = RestaurantsIndexRouteImport.update({
            id: '/restaurants/',path: '/restaurants/',getParentRoute: () => rootRouteImport
          })
const RestaurantsSlugRoute = RestaurantsSlugRouteImport.update({
            id: '/restaurants/$slug',path: '/restaurants/$slug',getParentRoute: () => rootRouteImport
          })
const SaunasIndexRoute = SaunasIndexRouteImport.update({
            id: '/saunas/',path: '/saunas/',getParentRoute: () => rootRouteImport
          })
const SaunasSlugRoute = SaunasSlugRouteImport.update({
            id: '/saunas/$slug',path: '/saunas/$slug',getParentRoute: () => rootRouteImport
          })
const SignTokenRoute = SignTokenRouteImport.update({
            id: '/sign/$token',path: '/sign/$token',getParentRoute: () => rootRouteImport
          })
const SkiResortsIndexRoute = SkiResortsIndexRouteImport.update({
            id: '/ski-resorts/',path: '/ski-resorts/',getParentRoute: () => rootRouteImport
          })
const SkiResortsSlugRoute = SkiResortsSlugRouteImport.update({
            id: '/ski-resorts/$slug',path: '/ski-resorts/$slug',getParentRoute: () => rootRouteImport
          })
const TicketTokenRoute = TicketTokenRouteImport.update({
            id: '/ticket/$token',path: '/ticket/$token',getParentRoute: () => rootRouteImport
          })
const TicketsIndexRoute = TicketsIndexRouteImport.update({
            id: '/tickets/',path: '/tickets/',getParentRoute: () => rootRouteImport
          })
const TicketsSlugRoute = TicketsSlugRouteImport.update({
            id: '/tickets/$slug',path: '/tickets/$slug',getParentRoute: () => rootRouteImport
          })
const AuthenticatedAdminIndexRoute = AuthenticatedAdminIndexRouteImport.update({
            id: '/admin/',path: '/admin/',getParentRoute: () => AuthenticatedRoute
          }).lazy(() => import('./routes/_authenticated/admin.index.lazy').then((d) => d.Route))
const AuthenticatedAdminPageRoute = AuthenticatedAdminPageRouteImport.update({
            id: '/admin/$page',path: '/admin/$page',getParentRoute: () => AuthenticatedRoute
          })
const AuthenticatedAdminAffiliateLinksRoute = AuthenticatedAdminAffiliateLinksRouteImport.update({
            id: '/admin/affiliate-links',path: '/admin/affiliate-links',getParentRoute: () => AuthenticatedRoute
          })
const AuthenticatedAdminApplicationsRoute = AuthenticatedAdminApplicationsRouteImport.update({
            id: '/admin/applications',path: '/admin/applications',getParentRoute: () => AuthenticatedRoute
          })
const AuthenticatedAdminBackupsRoute = AuthenticatedAdminBackupsRouteImport.update({
            id: '/admin/backups',path: '/admin/backups',getParentRoute: () => AuthenticatedRoute
          })
const AuthenticatedAdminCityHubQueueRoute = AuthenticatedAdminCityHubQueueRouteImport.update({
            id: '/admin/city-hub-queue',path: '/admin/city-hub-queue',getParentRoute: () => AuthenticatedRoute
          })
const AuthenticatedAdminCitySubmissionsRoute = AuthenticatedAdminCitySubmissionsRouteImport.update({
            id: '/admin/city-submissions',path: '/admin/city-submissions',getParentRoute: () => AuthenticatedRoute
          })
const AuthenticatedAdminCityTeamsRoute = AuthenticatedAdminCityTeamsRouteImport.update({
            id: '/admin/city-teams',path: '/admin/city-teams',getParentRoute: () => AuthenticatedRoute
          })
const AuthenticatedAdminCityTilesRoute = AuthenticatedAdminCityTilesRouteImport.update({
            id: '/admin/city-tiles',path: '/admin/city-tiles',getParentRoute: () => AuthenticatedRoute
          })
const AuthenticatedAdminCompressImagesRoute = AuthenticatedAdminCompressImagesRouteImport.update({
            id: '/admin/compress-images',path: '/admin/compress-images',getParentRoute: () => AuthenticatedRoute
          })
const AuthenticatedAdminDistrictsRoute = AuthenticatedAdminDistrictsRouteImport.update({
            id: '/admin/districts',path: '/admin/districts',getParentRoute: () => AuthenticatedRoute
          })
const AuthenticatedAdminImageOptimizationRoute = AuthenticatedAdminImageOptimizationRouteImport.update({
            id: '/admin/image-optimization',path: '/admin/image-optimization',getParentRoute: () => AuthenticatedRoute
          })
const AuthenticatedAdminLandmarksRoute = AuthenticatedAdminLandmarksRouteImport.update({
            id: '/admin/landmarks',path: '/admin/landmarks',getParentRoute: () => AuthenticatedRoute
          })
const AuthenticatedAdminListingRevisionsRoute = AuthenticatedAdminListingRevisionsRouteImport.update({
            id: '/admin/listing-revisions',path: '/admin/listing-revisions',getParentRoute: () => AuthenticatedRoute
          })
const AuthenticatedAdminLocationsRoute = AuthenticatedAdminLocationsRouteImport.update({
            id: '/admin/locations',path: '/admin/locations',getParentRoute: () => AuthenticatedRoute
          })
const AuthenticatedAdminMenusRoute = AuthenticatedAdminMenusRouteImport.update({
            id: '/admin/menus',path: '/admin/menus',getParentRoute: () => AuthenticatedRoute
          })
const AuthenticatedAdminMigrateRoute = AuthenticatedAdminMigrateRouteImport.update({
            id: '/admin/migrate',path: '/admin/migrate',getParentRoute: () => AuthenticatedRoute
          })
const AuthenticatedAdminMigrationAuditRoute = AuthenticatedAdminMigrationAuditRouteImport.update({
            id: '/admin/migration-audit',path: '/admin/migration-audit',getParentRoute: () => AuthenticatedRoute
          })
const AuthenticatedAdminOnboardingLiveSyncRoute = AuthenticatedAdminOnboardingLiveSyncRouteImport.update({
            id: '/admin/onboarding-live-sync',path: '/admin/onboarding-live-sync',getParentRoute: () => AuthenticatedRoute
          })
const AuthenticatedAdminPartnerEventsRoute = AuthenticatedAdminPartnerEventsRouteImport.update({
            id: '/admin/partner-events',path: '/admin/partner-events',getParentRoute: () => AuthenticatedRoute
          })
const AuthenticatedAdminPartnersRoute = AuthenticatedAdminPartnersRouteImport.update({
            id: '/admin/partners',path: '/admin/partners',getParentRoute: () => AuthenticatedRoute
          })
const AuthenticatedAdminPublishQueueRoute = AuthenticatedAdminPublishQueueRouteImport.update({
            id: '/admin/publish-queue',path: '/admin/publish-queue',getParentRoute: () => AuthenticatedRoute
          })
const AuthenticatedAdminSeoFixesRoute = AuthenticatedAdminSeoFixesRouteImport.update({
            id: '/admin/seo-fixes',path: '/admin/seo-fixes',getParentRoute: () => AuthenticatedRoute
          })
const AuthenticatedAdminServiceRequestsRoute = AuthenticatedAdminServiceRequestsRouteImport.update({
            id: '/admin/service-requests',path: '/admin/service-requests',getParentRoute: () => AuthenticatedRoute
          })
const AuthenticatedAdminTicketRoutesRoute = AuthenticatedAdminTicketRoutesRouteImport.update({
            id: '/admin/ticket-routes',path: '/admin/ticket-routes',getParentRoute: () => AuthenticatedRoute
          })
const AuthenticatedAdminTrainFactoryUsersRoute = AuthenticatedAdminTrainFactoryUsersRouteImport.update({
            id: '/admin/train-factory-users',path: '/admin/train-factory-users',getParentRoute: () => AuthenticatedRoute
          })
const AuthenticatedAdminTranslationsRoute = AuthenticatedAdminTranslationsRouteImport.update({
            id: '/admin/translations',path: '/admin/translations',getParentRoute: () => AuthenticatedRoute
          })
const AuthenticatedPartnerIndexRoute = AuthenticatedPartnerIndexRouteImport.update({
            id: '/partner/',path: '/partner/',getParentRoute: () => AuthenticatedRoute
          })
const AuthenticatedPartnerClientIdRoute = AuthenticatedPartnerClientIdRouteImport.update({
            id: '/partner/$clientId',path: '/partner/$clientId',getParentRoute: () => AuthenticatedRoute
          })
const AuthenticatedPartnerOnboardingRoute = AuthenticatedPartnerOnboardingRouteImport.update({
            id: '/partner/onboarding',path: '/partner/onboarding',getParentRoute: () => AuthenticatedRoute
          })
const AuthenticatedPartnerPendingRoute = AuthenticatedPartnerPendingRouteImport.update({
            id: '/partner/pending',path: '/partner/pending',getParentRoute: () => AuthenticatedRoute
          })
const AuthenticatedPartnerSetPasswordRoute = AuthenticatedPartnerSetPasswordRouteImport.update({
            id: '/partner/set-password',path: '/partner/set-password',getParentRoute: () => AuthenticatedRoute
          })
const BusinessCategoryKeyRoute = BusinessCategoryKeyRouteImport.update({
            id: '/category/$key',path: '/category/$key',getParentRoute: () => BusinessRoute
          })
const ContractsAcceptTokenRoute = ContractsAcceptTokenRouteImport.update({
            id: '/contracts/accept/$token',path: '/contracts/accept/$token',getParentRoute: () => rootRouteImport
          })
const CrmDiagnosticsLocationsRoute = CrmDiagnosticsLocationsRouteImport.update({
            id: '/diagnostics/locations',path: '/diagnostics/locations',getParentRoute: () => CrmRoute
          })
const CrmReportsContactsRoute = CrmReportsContactsRouteImport.update({
            id: '/contacts',path: '/contacts',getParentRoute: () => CrmReportsRoute
          })
const CrmReportsMonthlyRoute = CrmReportsMonthlyRouteImport.update({
            id: '/monthly',path: '/monthly',getParentRoute: () => CrmReportsRoute
          })
const CrmSalesUserIdRoute = CrmSalesUserIdRouteImport.update({
            id: '/$userId',path: '/$userId',getParentRoute: () => CrmSalesRoute
          })
const CrmSettingsRemindersRoute = CrmSettingsRemindersRouteImport.update({
            id: '/settings/reminders',path: '/settings/reminders',getParentRoute: () => CrmRoute
          })
const CrmSmmIndexRoute = CrmSmmIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => CrmSmmRoute
          })
const CrmSmmMembersRoute = CrmSmmMembersRouteImport.update({
            id: '/members',path: '/members',getParentRoute: () => CrmSmmRoute
          })
const CrmSmmReportsRoute = CrmSmmReportsRouteImport.update({
            id: '/reports',path: '/reports',getParentRoute: () => CrmSmmRoute
          })
const FiBarsIndexRoute = FiBarsIndexRouteImport.update({
            id: '/bars/',path: '/bars/',getParentRoute: () => FiRoute
          })
const FiBarsSlugRoute = FiBarsSlugRouteImport.update({
            id: '/bars/$slug',path: '/bars/$slug',getParentRoute: () => FiRoute
          })
const FiCafesIndexRoute = FiCafesIndexRouteImport.update({
            id: '/cafes/',path: '/cafes/',getParentRoute: () => FiRoute
          })
const FiCafesSlugRoute = FiCafesSlugRouteImport.update({
            id: '/cafes/$slug',path: '/cafes/$slug',getParentRoute: () => FiRoute
          })
const FiHappeningIndexRoute = FiHappeningIndexRouteImport.update({
            id: '/happening/',path: '/happening/',getParentRoute: () => FiRoute
          })
const FiHappeningSlugRoute = FiHappeningSlugRouteImport.update({
            id: '/happening/$slug',path: '/happening/$slug',getParentRoute: () => FiRoute
          })
const FiMenusIndexRoute = FiMenusIndexRouteImport.update({
            id: '/menus/',path: '/menus/',getParentRoute: () => FiRoute
          })
const FiNationalParksIndexRoute = FiNationalParksIndexRouteImport.update({
            id: '/national-parks/',path: '/national-parks/',getParentRoute: () => FiRoute
          })
const FiNationalParksSlugRoute = FiNationalParksSlugRouteImport.update({
            id: '/national-parks/$slug',path: '/national-parks/$slug',getParentRoute: () => FiRoute
          })
const FiPlaceIdRoute = FiPlaceIdRouteImport.update({
            id: '/place/$id',path: '/place/$id',getParentRoute: () => FiRoute
          })
const FiPubsIndexRoute = FiPubsIndexRouteImport.update({
            id: '/pubs/',path: '/pubs/',getParentRoute: () => FiRoute
          })
const FiPubsSlugRoute = FiPubsSlugRouteImport.update({
            id: '/pubs/$slug',path: '/pubs/$slug',getParentRoute: () => FiRoute
          })
const FiRestaurantsIndexRoute = FiRestaurantsIndexRouteImport.update({
            id: '/restaurants/',path: '/restaurants/',getParentRoute: () => FiRoute
          })
const FiRestaurantsSlugRoute = FiRestaurantsSlugRouteImport.update({
            id: '/restaurants/$slug',path: '/restaurants/$slug',getParentRoute: () => FiRoute
          })
const FiSaunasIndexRoute = FiSaunasIndexRouteImport.update({
            id: '/saunas/',path: '/saunas/',getParentRoute: () => FiRoute
          })
const FiSaunasSlugRoute = FiSaunasSlugRouteImport.update({
            id: '/saunas/$slug',path: '/saunas/$slug',getParentRoute: () => FiRoute
          })
const FiSkiResortsIndexRoute = FiSkiResortsIndexRouteImport.update({
            id: '/ski-resorts/',path: '/ski-resorts/',getParentRoute: () => FiRoute
          })
const FiSkiResortsSlugRoute = FiSkiResortsSlugRouteImport.update({
            id: '/ski-resorts/$slug',path: '/ski-resorts/$slug',getParentRoute: () => FiRoute
          })
const TicketsConfirmationOrderIdRoute = TicketsConfirmationOrderIdRouteImport.update({
            id: '/tickets/confirmation/$orderId',path: '/tickets/confirmation/$orderId',getParentRoute: () => rootRouteImport
          })
const AuthenticatedAdminMenusSlugRoute = AuthenticatedAdminMenusSlugRouteImport.update({
            id: '/$slug',path: '/$slug',getParentRoute: () => AuthenticatedAdminMenusRoute
          })
const AuthenticatedDistrictsSlugManageRoute = AuthenticatedDistrictsSlugManageRouteImport.update({
            id: '/districts/$slug/manage',path: '/districts/$slug/manage',getParentRoute: () => AuthenticatedRoute
          })





const AuthenticatedAdminMenusRouteChildren = {
  AuthenticatedAdminMenusSlugRoute: AuthenticatedAdminMenusSlugRoute
}

const AuthenticatedAdminMenusRouteWithChildren = AuthenticatedAdminMenusRoute._addFileChildren(AuthenticatedAdminMenusRouteChildren)



const AuthenticatedRouteChildren = {
  AuthenticatedAgreementsRoute: AuthenticatedAgreementsRoute,AuthenticatedBusinessAdminRoute: AuthenticatedBusinessAdminRoute,AuthenticatedCityRoute: AuthenticatedCityRoute,AuthenticatedCityHubRoute: AuthenticatedCityHubRoute,AuthenticatedCityTasksRoute: AuthenticatedCityTasksRoute,AuthenticatedStorageCheckRoute: AuthenticatedStorageCheckRoute,AuthenticatedVenueManagerRoute: AuthenticatedVenueManagerRoute,AuthenticatedAdminPageRoute: AuthenticatedAdminPageRoute,AuthenticatedAdminAffiliateLinksRoute: AuthenticatedAdminAffiliateLinksRoute,AuthenticatedAdminApplicationsRoute: AuthenticatedAdminApplicationsRoute,AuthenticatedAdminBackupsRoute: AuthenticatedAdminBackupsRoute,AuthenticatedAdminCityHubQueueRoute: AuthenticatedAdminCityHubQueueRoute,AuthenticatedAdminCitySubmissionsRoute: AuthenticatedAdminCitySubmissionsRoute,AuthenticatedAdminCityTeamsRoute: AuthenticatedAdminCityTeamsRoute,AuthenticatedAdminCityTilesRoute: AuthenticatedAdminCityTilesRoute,AuthenticatedAdminCompressImagesRoute: AuthenticatedAdminCompressImagesRoute,AuthenticatedAdminDistrictsRoute: AuthenticatedAdminDistrictsRoute,AuthenticatedAdminImageOptimizationRoute: AuthenticatedAdminImageOptimizationRoute,AuthenticatedAdminLandmarksRoute: AuthenticatedAdminLandmarksRoute,AuthenticatedAdminListingRevisionsRoute: AuthenticatedAdminListingRevisionsRoute,AuthenticatedAdminLocationsRoute: AuthenticatedAdminLocationsRoute,AuthenticatedAdminMenusRoute: AuthenticatedAdminMenusRouteWithChildren,AuthenticatedAdminMigrateRoute: AuthenticatedAdminMigrateRoute,AuthenticatedAdminMigrationAuditRoute: AuthenticatedAdminMigrationAuditRoute,AuthenticatedAdminOnboardingLiveSyncRoute: AuthenticatedAdminOnboardingLiveSyncRoute,AuthenticatedAdminPartnerEventsRoute: AuthenticatedAdminPartnerEventsRoute,AuthenticatedAdminPartnersRoute: AuthenticatedAdminPartnersRoute,AuthenticatedAdminPublishQueueRoute: AuthenticatedAdminPublishQueueRoute,AuthenticatedAdminSeoFixesRoute: AuthenticatedAdminSeoFixesRoute,AuthenticatedAdminServiceRequestsRoute: AuthenticatedAdminServiceRequestsRoute,AuthenticatedAdminTicketRoutesRoute: AuthenticatedAdminTicketRoutesRoute,AuthenticatedAdminTrainFactoryUsersRoute: AuthenticatedAdminTrainFactoryUsersRoute,AuthenticatedAdminTranslationsRoute: AuthenticatedAdminTranslationsRoute,AuthenticatedPartnerClientIdRoute: AuthenticatedPartnerClientIdRoute,AuthenticatedPartnerOnboardingRoute: AuthenticatedPartnerOnboardingRoute,AuthenticatedPartnerPendingRoute: AuthenticatedPartnerPendingRoute,AuthenticatedPartnerSetPasswordRoute: AuthenticatedPartnerSetPasswordRoute,AuthenticatedAdminIndexRoute: AuthenticatedAdminIndexRoute,AuthenticatedPartnerIndexRoute: AuthenticatedPartnerIndexRoute,AuthenticatedDistrictsSlugManageRoute: AuthenticatedDistrictsSlugManageRoute
}

const AuthenticatedRouteWithChildren = AuthenticatedRoute._addFileChildren(AuthenticatedRouteChildren)




const BusinessRouteChildren = {
  BusinessCitiesRoute: BusinessCitiesRoute,BusinessEventsRoute: BusinessEventsRoute,BusinessIndexRoute: BusinessIndexRoute,BusinessCategoryKeyRoute: BusinessCategoryKeyRoute
}

const BusinessRouteWithChildren = BusinessRoute._addFileChildren(BusinessRouteChildren)




const CrmReportsRouteChildren = {
  CrmReportsContactsRoute: CrmReportsContactsRoute,CrmReportsMonthlyRoute: CrmReportsMonthlyRoute
}

const CrmReportsRouteWithChildren = CrmReportsRoute._addFileChildren(CrmReportsRouteChildren)




const CrmSalesRouteChildren = {
  CrmSalesUserIdRoute: CrmSalesUserIdRoute
}

const CrmSalesRouteWithChildren = CrmSalesRoute._addFileChildren(CrmSalesRouteChildren)




const CrmSmmRouteChildren = {
  CrmSmmMembersRoute: CrmSmmMembersRoute,CrmSmmReportsRoute: CrmSmmReportsRoute,CrmSmmIndexRoute: CrmSmmIndexRoute
}

const CrmSmmRouteWithChildren = CrmSmmRoute._addFileChildren(CrmSmmRouteChildren)



const CrmRouteChildren = {
  CrmClientIdRoute: CrmClientIdRoute,CrmAccessRoute: CrmAccessRoute,CrmApplicationsRoute: CrmApplicationsRoute,CrmChatRoute: CrmChatRoute,CrmClosedDealsRoute: CrmClosedDealsRoute,CrmDashboardRoute: CrmDashboardRoute,CrmInvoicesRoute: CrmInvoicesRoute,CrmLogsRoute: CrmLogsRoute,CrmMapRoute: CrmMapRoute,CrmMyWorkRoute: CrmMyWorkRoute,CrmProfileRoute: CrmProfileRoute,CrmReportsRoute: CrmReportsRouteWithChildren,CrmSalesRoute: CrmSalesRouteWithChildren,CrmSmmRoute: CrmSmmRouteWithChildren,CrmTasksRoute: CrmTasksRoute,CrmIndexRoute: CrmIndexRoute,CrmDiagnosticsLocationsRoute: CrmDiagnosticsLocationsRoute,CrmSettingsRemindersRoute: CrmSettingsRemindersRoute
}

const CrmRouteWithChildren = CrmRoute._addFileChildren(CrmRouteChildren)




const FiRouteChildren = {
  FiCitySlugRoute: FiCitySlugRoute,FiCitiesRoute: FiCitiesRoute,FiDoRoute: FiDoRoute,FiEatRoute: FiEatRoute,FiIndexRoute: FiIndexRoute,FiBarsSlugRoute: FiBarsSlugRoute,FiCafesSlugRoute: FiCafesSlugRoute,FiHappeningSlugRoute: FiHappeningSlugRoute,FiNationalParksSlugRoute: FiNationalParksSlugRoute,FiPlaceIdRoute: FiPlaceIdRoute,FiPubsSlugRoute: FiPubsSlugRoute,FiRestaurantsSlugRoute: FiRestaurantsSlugRoute,FiSaunasSlugRoute: FiSaunasSlugRoute,FiSkiResortsSlugRoute: FiSkiResortsSlugRoute,FiBarsIndexRoute: FiBarsIndexRoute,FiCafesIndexRoute: FiCafesIndexRoute,FiHappeningIndexRoute: FiHappeningIndexRoute,FiMenusIndexRoute: FiMenusIndexRoute,FiNationalParksIndexRoute: FiNationalParksIndexRoute,FiPubsIndexRoute: FiPubsIndexRoute,FiRestaurantsIndexRoute: FiRestaurantsIndexRoute,FiSaunasIndexRoute: FiSaunasIndexRoute,FiSkiResortsIndexRoute: FiSkiResortsIndexRoute
}

const FiRouteWithChildren = FiRoute._addFileChildren(FiRouteChildren)

const rootRouteChildren = {
  IndexRoute: IndexRoute,CitySlugRoute: CitySlugRoute,AuthenticatedRoute: AuthenticatedRouteWithChildren,AiRoute: AiRoute,BusinessRoute: BusinessRouteWithChildren,CitiesRoute: CitiesRoute,ContactRoute: ContactRoute,CrmRoute: CrmRouteWithChildren,DoRoute: DoRoute,EatRoute: EatRoute,FiRoute: FiRouteWithChildren,HelpRoute: HelpRoute,LoginRoute: LoginRoute,MapRoute: MapRoute,MyEventsRoute: MyEventsRoute,OnboardingRoute: OnboardingRoute,PrivacyRoute: PrivacyRoute,ProfileRoute: ProfileRoute,ReferRoute: ReferRoute,RegisterRoute: RegisterRoute,SavedRoute: SavedRoute,SearchRoute: SearchRoute,SubmitEventRoute: SubmitEventRoute,TermsRoute: TermsRoute,TrainFactoryRoute: TrainFactoryRoute,VenueEventsRoute: VenueEventsRoute,AcceptTokenRoute: AcceptTokenRoute,AdminLoginRoute: AdminLoginRoute,BarsSlugRoute: BarsSlugRoute,CafesSlugRoute: CafesSlugRoute,CityHubSlugRoute: CityHubSlugRoute,CityInviteTokenRoute: CityInviteTokenRoute,DistrictsSlugRoute: DistrictsSlugRoute,Guides48HoursInHelsinkiRoute: Guides48HoursInHelsinkiRoute,GuidesBestSaunasHelsinkiRoute: GuidesBestSaunasHelsinkiRoute,GuidesHelsinkiNeighborhoodsRoute: GuidesHelsinkiNeighborhoodsRoute,HappeningSlugRoute: HappeningSlugRoute,HelsinkiofficialFeedRoute: HelsinkiofficialFeedRoute,HelsinkiofficialStoriesRoute: HelsinkiofficialStoriesRoute,MenuSlugRoute: MenuSlugRoute,NationalParksSlugRoute: NationalParksSlugRoute,OnboardTokenRoute: OnboardTokenRoute,PartnerApplyRoute: PartnerApplyRoute,PartnerLoginRoute: PartnerLoginRoute,PartnerRegisterRoute: PartnerRegisterRoute,PlaceIdRoute: PlaceIdRoute,PubsSlugRoute: PubsSlugRoute,RestaurantsSlugRoute: RestaurantsSlugRoute,SaunasSlugRoute: SaunasSlugRoute,SignTokenRoute: SignTokenRoute,SkiResortsSlugRoute: SkiResortsSlugRoute,TicketTokenRoute: TicketTokenRoute,TicketsSlugRoute: TicketsSlugRoute,BarsIndexRoute: BarsIndexRoute,CafesIndexRoute: CafesIndexRoute,DistrictsIndexRoute: DistrictsIndexRoute,HappeningIndexRoute: HappeningIndexRoute,MenusIndexRoute: MenusIndexRoute,NationalParksIndexRoute: NationalParksIndexRoute,PubsIndexRoute: PubsIndexRoute,RestaurantsIndexRoute: RestaurantsIndexRoute,SaunasIndexRoute: SaunasIndexRoute,SkiResortsIndexRoute: SkiResortsIndexRoute,TicketsIndexRoute: TicketsIndexRoute,ContractsAcceptTokenRoute: ContractsAcceptTokenRoute,TicketsConfirmationOrderIdRoute: TicketsConfirmationOrderIdRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)